export default "__VITE_ASSET__BE4vgte0__"